import { render, staticRenderFns } from "./new_mini_program.vue?vue&type=template&id=3c4702d0&"
import script from "./new_mini_program.vue?vue&type=script&lang=js&"
export * from "./new_mini_program.vue?vue&type=script&lang=js&"
import style0 from "./new_mini_program.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports